/**
 * A config containing properties for wizard
 */
var WizardConfig = /** @class */ (function () {
    function WizardConfig() {
    }
    return WizardConfig;
}());
export { WizardConfig };
//# sourceMappingURL=wizard-config.js.map